import { render, staticRenderFns } from "./inWarehouse.vue?vue&type=template&id=c32248c0&scoped=true"
import script from "./inWarehouse.vue?vue&type=script&lang=js"
export * from "./inWarehouse.vue?vue&type=script&lang=js"
import style0 from "./inWarehouse.vue?vue&type=style&index=0&id=c32248c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32248c0",
  null
  
)

export default component.exports